import React, { useEffect } from 'react';
import { Box, Typography } from '@material-ui/core';
import { PAGE_NOT_FOUND_MESSAGE } from '../../content';
import { Routes } from '../../constants';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useHistory, useLocation } from 'react-router';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '92vh',
      backgroundColor: 'white',
    },
    errorText: {
      color: '#333',
      fontSize: '18px',
      fontWeight: 400,
      textAlign: 'center',
    },
  })
);

const NotFound: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { uiAudienceStudioVisible = false } = useFlags();
  const { isFirstLogin } = location.state || {};

  useEffect(() => {
    if (isFirstLogin && !uiAudienceStudioVisible) {
      history.push(Routes.OFFER_WALL_MANAGER);
    }
  }, [isFirstLogin]);

  return (
    <Box className={classes.root}>
      <Typography className={classes.errorText}>
        {PAGE_NOT_FOUND_MESSAGE}
      </Typography>
    </Box>
  );
};

export default NotFound;
